import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { authAPI } from '../services/api';
import { Button } from '../components/Common/Button';
import { Input } from '../components/Common/Input';
import { Label } from '../components/Common/Label';
import { Advice, LoginBack, LoginHeader } from '../components/Common/Card';
import { Resend, Pass_Key } from '../components/Icons/CustomIcons';
import { IconContainer, AuthDesktopHeader } from '../components/Common/Dialog';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sentTo, setSentTo] = useState('');
  const [status, setStatus] = useState('idle'); // 'idle' | 'loading' | 'sent' | 'error'
  const [error, setError] = useState('');
  const [resendStatus, setResendStatus] = useState('');
  const returnTo = '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResendStatus('');
    setStatus('loading');
    try {
      await authAPI.forgotPassword(email);
      setSentTo(email);
      setStatus('sent');
    } catch {
      setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
      setStatus('error');
    }
  };

  const handleResend = async () => {
    setResendStatus('');
    try {
      await authAPI.forgotPassword(sentTo);
      setResendStatus('Link wurde erneut gesendet.');
    } catch {
      setResendStatus('Fehler beim Senden. Bitte versuchen Sie es später erneut.');
    }
  };

  const bgStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/GrosselternMitKindern.png)`,
  };

  return (
    <div className="auth-fullpage" style={bgStyle}>    
      <LoginBack returnTo={returnTo} />   
      <div>   
        <span className="auth-fullpage-mobile-only"><IconContainer Icon={Pass_Key} /></span>
        <LoginHeader
          title="Passwort zurücksetzen"
          subtitle="Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link, mit dem Sie ein neues Passwort festlegen können."
        />
      </div>
      <div className="auth-fullpage-panel">
        <AuthDesktopHeader
          title="Passwort zurücksetzen"
          subtitle="Geben Sie Ihre E-Mail-Adresse ein, um einen Link zum Zurücksetzen Ihres Passworts zu erhalten."
        />
        <div className="auth-panel-body">

          {status === 'sent' ? (
            <div className="ml-form">
              <h2 className="ml-success-title" style={{ textAlign: 'left' }}>
                Bitte prüfen Sie Ihre E-Mails.
              </h2>
              <p style={{ margin: 0 }}>Wir haben einen Link an diese Adresse gesendet:</p>
              <Input
                type="email"
                value={sentTo}
                readOnly
                aria-label="E-Mail-Adresse"
                className="ml-sent-email-input"
              />
              {resendStatus && (
                <p className="ml-resend-ok">{resendStatus}</p>
              )}
              <Button type="button" className="w-full" onClick={handleResend}>
                <Resend size={28} aria-hidden="true" style={{ marginLeft: '0.5rem' }} />
                Link noch einmal senden
              </Button>             
              <Advice text="Keine E-Mail erhalten? Bitte prüfen Sie auch den Spam-Ordner." />
            </div>
          ) : (
            <>
              {error && (
                <div className="error-message" role="alert" style={{ marginBottom: 'var(--spacing-4)' }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="ml-form">
                <div className="ml-field">
                  <Label className="auth-label" htmlFor="forgot-email">E-Mail-Adresse</Label>
                  <Input
                    id="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ihre@email.com"
                    required
                    autoFocus
                  />

                  <p className="ml-field-hint">
                    Bitte geben Sie die E-Mail-Adresse ein, mit der Sie sich registriert haben.
                  </p>
                </div>
                <Button type="submit" className="w-full" disabled={status === 'loading'}>
                  {status === 'loading' ? 'Wird gesendet…' : (
                    <>
                      Link senden
                      <ArrowRight size={28} aria-hidden="true" style={{ marginLeft: '0.5rem' }} />
                    </>
                  )}
                </Button>    
                            
                <Advice text="Keine E-Mail erhalten? Bitte prüfen Sie auch den Spam-Ordner." />
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
